import { InfoCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';
import { getTaxPaymentMethodLabel } from 'store/declarations/enums/ireland/tax-payment-method';
import IconTooltip from 'components/new-ui/base/tooltip/IconTooltip';
import useTooltips from 'hooks/useTooltips';
import CalculationsHeaderSummaryItem from './CalculationsHeaderSummaryItem';
import { formatValue } from '../utils';

const StyledHeader = styled.header`
    background-color: var(--blue-1);
    border: 1px solid var(--blue-3);
    border-radius: 6px;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

type Props = {
    methodOfPayment: string | undefined;
    totalVat: number;
    totalDuty: number;
    totalLiability: number;
};

const CalculationsSummaryHeader = ({ methodOfPayment, totalDuty, totalLiability, totalVat }: Props) => {
    const { getH1TooltipsByRefNumber } = useTooltips();
    const paymentMethodLabel = getTaxPaymentMethodLabel(methodOfPayment);

    return (
        <StyledHeader>
            <CalculationsHeaderSummaryItem
                name="Method of Payment"
                value={paymentMethodLabel ?? 'Unknown payment method'}
                icon={
                    <IconTooltip
                        icon={<InfoCircleFilled style={{ color: 'var(--blue-8)', fontSize: 16 }} />}
                        title={getH1TooltipsByRefNumber('4.8')}
                    />
                }
            />
            <CalculationsHeaderSummaryItem name="Total Duties" value={formatValue(totalDuty)} />
            <CalculationsHeaderSummaryItem name="Total VAT" value={formatValue(totalVat)} />
            <CalculationsHeaderSummaryItem name="Local Total Liability" value={formatValue(totalLiability)} />
        </StyledHeader>
    );
};

export default CalculationsSummaryHeader;
